module.exports = "<span id=organizationName-span>{{ $ctrl.organization.name }}</span> ";